import {
   ApiResponse,
   createApiRequest,
   Header,
   getHeaderFromSessionStorage,
} from "."
import { API_URL, Endpoints } from "@/constants/endpoints"
import { HttpMethods } from "@/constants/globals"

const ALARM_SCHEDULES_URL = `${API_URL}${Endpoints.ALERTS}schedule/`

export interface AlarmScheduleWindow {
   id?: string
   weekday: number
   startTime: string
   endTime: string
}

export interface AlarmScheduleResponse {
   id: string
   level: string
   alertConfiguration: string
   windows: Required<AlarmScheduleWindow>[]
   timezone: string
}

export interface AlarmScheduleCreateRequest {
   level: string
   alertConfiguration: string
   windows: AlarmScheduleWindow[]
}

export async function requestAlarmSchedules(): Promise<
   ApiResponse<AlarmScheduleResponse[]>
> {
   const response = await createApiRequest(
      ALARM_SCHEDULES_URL,
      HttpMethods.GET,
      null,
      getHeaderFromSessionStorage(Header.FACILITY_ID)
   )
   return response
}

export async function requestLevelAlarmSchedules(
   levelId: string
): Promise<ApiResponse<AlarmScheduleResponse[]>> {
   const response = await createApiRequest(
      `${ALARM_SCHEDULES_URL}?level=${encodeURIComponent(levelId)}`,
      HttpMethods.GET,
      null,
      getHeaderFromSessionStorage(Header.FACILITY_ID)
   )
   return response
}

export async function requestCreateAlarmSchedule(
   alarmSchedule: AlarmScheduleCreateRequest
): Promise<ApiResponse<AlarmScheduleResponse>> {
   const response = await createApiRequest(
      ALARM_SCHEDULES_URL,
      HttpMethods.POST,
      alarmSchedule,
      getHeaderFromSessionStorage(Header.FACILITY_ID)
   )
   return response
}

export interface AlarmScheduleUpdateRequest {
   level?: string
   windows?: AlarmScheduleWindow[]
}

export async function requestUpdateAlarmSchedule(
   alarmScheduleId: string,
   alarmSchedule: AlarmScheduleUpdateRequest
): Promise<ApiResponse<AlarmScheduleResponse>> {
   const response = await createApiRequest(
      `${ALARM_SCHEDULES_URL}${alarmScheduleId}/`,
      HttpMethods.PATCH,
      alarmSchedule,
      getHeaderFromSessionStorage(Header.FACILITY_ID)
   )
   return response
}

export async function requestDeleteAlarmSchedule(
   alarmScheduleId: string
): Promise<ApiResponse<null>> {
   const response = await createApiRequest(
      `${ALARM_SCHEDULES_URL}${alarmScheduleId}/`,
      HttpMethods.DELETE,
      null,
      getHeaderFromSessionStorage(Header.FACILITY_ID)
   )
   return response
}
